import { Component, inject, input, LOCALE_ID, output, signal } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { Loading } from '../../../../utils/loading/loading';
import { Error } from '../../../public-user-component/auth/shared/error/error';

@Component({
  selector: 'app-pharamcist-name',
  imports: [ReactiveFormsModule, Loading, Error],
  templateUrl: './pharamcist-name.html',
  styleUrl: './pharamcist-name.scss',
})
export class PharamcistName {
  private locale = inject(LOCALE_ID);
  pharmacyForm = input.required<FormGroup>();
  showFullNameDropdown = input.required<boolean>();
  fullNameResults = input.required<{ id: number; fullName: string }[]>();
  selectedPharmacistName = signal<string>('');
  selectFullName = output<{
    id: string;
    fullName: string;
  }>();
  loadingPharmacist = input.required<boolean>();
  errorPharmacist = input.required<boolean>();

  onSelectFullName(id: string, fullName: string) {
    this.selectedPharmacistName.set(fullName);
    this.selectFullName.emit({ id, fullName });
  }

  isArabic() {
    return this.locale.startsWith('ar');
  }
}
